export const normalizeTeamApiResponse = (response, fallbackMessage) => {
    if (response?.data?.success === false) {
        return {
            ...response,
            success: false,
            status: response?.status,
            message:
                response?.data?.message ??
                response?.data?.Message ??
                fallbackMessage,
        };
    }

    return {
        ...response,
        success: true,
        status: response?.status,
    };
};

export const normalizeTeamApiError = (error, fallbackMessage) => ({
    success: false,
    status: error?.response?.status,
    message:
        error?.response?.data?.message ??
        error?.response?.data?.Message ??
        error?.message ??
        fallbackMessage,
});
